export default "__VITE_ASSET__DH$rt$MK__"